import { authService, routingService, stateService, translateService } from "../../../services/imports";
import { states } from "../../../models/imports";

// After a document link's exchange filled this tab's slot: read userInfo
// (a share link's carries the recipient's language; a public view's has no
// language, so the page keeps its own) and open the document. The address
// is replaced, so the link's value leaves the address bar and the history.
export default function startDocumentSession(slot) {
  const open = () =>
    routingService.replace(routingService.routeNames.viewResult, { params: { id: slot.docId } });

  authService.clearCache("userInfo");
  authService.userInfo().subscribe(
    (res) => {
      if (res && res.success && res.data) {
        stateService.setState(states.userInfo, res.data);
        if (res.data.localeId) translateService.use(res.data.localeId, res.data.localeCode);
      }
      open();
    },
    () => open()
  );
}
